<template>
    <div class="libary_main_libray_div">
        <Library :data="doc_id" @message_back="message_back"></Library>
        <div v-for="facet in library_content" :key="facet.id">
            <div class="libary_main_libray_content_header">
                <h5>{{facet.name}}</h5>
                <router-link class="more_library_a" tag="a" :to="{ name: 'library', query: {'fid': facet.id} }">更多
                </router-link>
            </div>
            <div class="libary_main_libray_content_cards">
                <div class="libray_main_library_content_card" v-for="md in facet.docs" :key="md.id">
                    <div @click="openDocumentDialog(md)">
                        <LibraryCard :data="md"></LibraryCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import documentApi from '@/api/document/document.js'
    import LibraryCard from '@/components/common_components/cards/library_card.vue'
    // import DocumentDialog from '@/components/common_components/dialog/document_dialog.vue'
    import Library from '@/components/library_page/library_item.vue'

    import {mapState} from 'vuex'

    export default {
        data() {
            return {
                showDialog: false,
                document_access: false,
                documentData: null,
                doc_id: ''
            }
        },
        components: {
            LibraryCard,
            // DocumentDialog,
            Library,
        },
        methods: {
            openDocumentDialog(doc) {
                this.doc_id = String(doc.id)
            },
            message_back: function () {
                this.$router.push({name: 'library'});
                this.doc_id = ''
            },
        },
        computed: {
            ...mapState({
                // index_content: state => state.library.index_content,
                library_content: state => state.library.library_content
            }),
            // _library_content: function () {
            // if (!this.$route.query.fid) {
            //     return this.index_content
            // }
            // 好像没有上一页下一页的需求...
            // let c = this.library_content
            // let newC = {'previous': c.previous, 'next': c.next, facets:[{
            //     'id': this.$route.query.fid,
            //     'tags': c.results
            // }]}
            //     return this.library_content
            // }
        }
    }
</script>
<style type="text/css" scoped>
    .libary_main_libray_div {
        width: 74%;
        margin-left: 15px;
        background: #fff;
        border: 1px solid #eee;
        padding: 15px;
    }

    .libary_main_libray_content_header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    .libary_main_libray_content_cards {
        display: flex;
        flex-wrap: wrap;
    }

    .libray_main_library_content_card {
        width: 33%;
        padding: 0 15px;
    }

    .more_library_a {
        font-size: 1rem;
        color: #666;
    }


</style>